// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"DoubleLargeImage_imageContainer__6wKQd","image":"DoubleLargeImage_image__1mSdS"};